<!-- TODO CSSの調整 -->
<template>
  <div>
    <hr>
    <div class="risk--container">
      <!-- リスク分析の項目名を表示する -->
      <display-value
        :value="$store.state.labels.factorLabels[factorCode]"
        class="risk--content risk--content__label"
      />
      <component
        :is="componentName"
        :value="diseaseCurrentValue"
        class="risk--content risk--content__user-value"
      />
      <component
        :is="componentName"
        :value="convertValue"
        class="risk--content risk--content__convert-value"
      />

      <div class="risk--content risk--content__persentage" :class="{'is-positive': isPositive}">
        <triangle :value="riskIncreaseAndDecrease" v-if="riskIncreaseAndDecrease !== 0" />
        <display-value :value="riskIncreaseAndDecrease | valueOfAbs" />
        <div>%</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

import Triangle from "../../atoms/Triangle";
import DisplayValue from "../../atoms/displayValue/DisplayValue";

export default {
  props: {
    factorCode: VueTypes.string.isRequired,
    diseaseCurrentValue: VueTypes.number.isRequired,
    convertValue: VueTypes.number.isRequired,
    riskIncreaseAndDecrease: VueTypes.number.isRequired
  },
  components: {
    Triangle,
    DisplayValue
  },
  computed: {
    componentName() {
      // 表示アトムを切り替える
      let name = null;
      if (this.factorCode === "SMK_STAT_TYPE_RSPS_CD") {
        name = "DisplaySmokingHabit";
      } else if (this.factorCode === "OLIG_PROTE_CD") {
        name = "DisplayUrinaryTest";
      } else {
        return "DisplayValue";
      }
      return () => import(`../../atoms/displayValue/${name}`);
    },
    isPositive() {
      return this.riskIncreaseAndDecrease > 0 ? true : false;
    }
  },
  filters: {
    valueOfAbs: function(value) {
      return Math.abs(value);
    }
  }
};
</script>

<style scoped>
.risk--container {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  margin-top: 20px;
  line-height: 20px;
}
.risk--content {
  align-self: center;
}

.risk--content__persentage {
  display: flex;
  justify-content: center;
}
.risk--content__label {
  justify-self: start;
  align-self: center;
}

.is-positive {
  color: #d3455b;
}
</style>
